import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { APIEndpoints } from "../../../../config/apiEndpoint.config";

@Injectable()
export class BuildingSearchService {
  constructor(private http: HttpClient) {}

  searchBuildings(page: number, searchValue: string): Observable<any> {
    return this.http.get<any>(
      APIEndpoints.search + `?page=${page}&searchQuery=${searchValue}`
    );
  }
}
